import React from 'react'

export default (
	<svg width='47' height='47' viewBox='0 0 42 42'>
		<defs>
			<linearGradient
				id='security-a'
				x1='0%'
				x2='95.861%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#134AA7' />
				<stop offset='100%' stopColor='#506CF9' />
			</linearGradient>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{/* <circle
				cx='21'
				cy='21'
				r='21'
				fill='url(#security-a)'
				opacity='.35'
			/> */}
			<g transform='translate(5 5)'>
				<circle
					cx='16'
					cy='16'
					r='16'
					fill='url(#security-a)'
				/>
				<path
					fill='#FFF'
					d='M21.280949,18.4323642 C21.2813932,19.8022398 20.5511189,21.068108 19.3648119,21.7530459 L17.7873659,22.6419982 C16.6663969,23.2887111 15.2854094,23.2887111 14.1648849,22.6419982 L12.58655,21.7530459 C11.4011319,21.0672191 10.671302,19.8017954 10.6708508,18.4323642 L10.6708508,12.6097261 C10.6690797,12.1208023 11.0171045,11.6998833 11.4980278,11.6096547 C12.3043076,11.4620886 13.0976976,11.2509624 13.8715306,10.9784985 C14.4506831,10.7762618 15.0173903,10.5402449 15.5689852,10.2717813 C15.8241145,10.146439 16.123247,10.146439 16.3783764,10.2717813 C16.9299713,10.5402449 17.4966785,10.7762618 18.0762754,10.9784985 C18.8492195,11.2509624 19.643054,11.4620886 20.4497783,11.6096547 C20.930257,11.6998833 21.2782819,12.1208023 21.2760595,12.6097261 L21.280949,18.4323642 Z M23.1566383,9.16059084 L22.8188364,9.16059084 C21.5027424,9.14414522 20.1986492,8.90857283 18.9603386,8.46276321 C18.0696083,8.15074093 17.2166585,7.73915597 16.4183792,7.2364534 C16.1548048,7.06933035 15.8187808,7.06933035 15.5560954,7.2364534 C14.7489266,7.74137835 13.8870873,8.15296331 12.9865785,8.46276321 C11.7504902,8.90946179 10.4477305,9.14681207 9.13296993,9.1650356 L8.8311706,9.1650356 C8.37958279,9.15792398 8.00711174,9.51794969 8,9.96953751 L8,9.96953751 L8,18.4145852 C7.99955564,20.7378622 9.23786632,22.8842378 11.2491211,24.0460985 L12.8265671,24.9350509 C14.7724839,26.0586867 17.1704329,26.0586867 19.1163497,24.9350509 L20.6942402,24.0460985 C22.7059394,22.8851267 23.9446946,20.7378622 23.9429186,18.4145852 L23.9429186,9.96953751 C23.9406943,9.53261741 23.5935584,9.17481407 23.1566383,9.16059084 L23.1566383,9.16059084 Z'
				/>
			</g>
		</g>
	</svg>
)
